import request from '@/utils/request'

//获取进度列表
export function sectionlist(data) {
	return request({
		url: '/user/section/list',
		method: 'get',
		params: data
	})
}

//更新进度
export function sectionupdate(data) {
	return request({
		url: '/user/section/update',
		method: 'post',
		data
	})
}